
<template>
  <div class="info_detail">
    <h4 class="title">{{articleJson.title}}</h4>
    <p class="time"><span class="eyes"></span>{{articleJson.peopleNum}} <span class="mg">发布于{{util.getTimer(articleJson.time)}}</span></p>
    <div class="con"
         v-html="articleJson.content">
    </div>
    <p class="bottom">如有侵权,请联系删除</p>
  </div>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      id: '',
      articleJson: {},
      content: `<p></p><p></p><p></p><p></p><p></p><p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;疫情，给经济按下了“暂停”键。企业没有了收入，大多处于水生火热之中。但人民日报的好消息不断，连续16连降，告诉我们：这一切终将过去，复工之时指日可待！<br><br>    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;疫情，是危机。但危机背后，也是转机。有人看了本次标题，肯定会问：但，现在还是没复工啊，要准备贷款干嘛？<br><br>    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;今天，我就告诉你为何要提前准备贷款？有两点需要<br>先与你分享：<br><br>    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;“首先疫情后，几大行业需求量将迎来爆发式增长，同时迎来的也是资金缺口；其次疫情期间，央行经为<br><br></p><p><br></p><p></p><p></p><p></p><p></p><p></p>`
    }
  },
  mounted () {
    this.util.title('资讯详情');
    this.id = this.$route.query.id;
    this.getArticleDetail();
  },
  methods: {
    getArticleDetail () {//
      let _this = this;
      let param = {
        id: this.id
      }
      this.$get('/app/v1/news/getById', param)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            this.articleJson = e.data;
          }
          else {
            _this.util.toast({ msg: e.message })
          }
        })
        .catch(error => { });
    },
  }

}
</script>
<style scoped>
.info_detail {
  width: 100%;
  background: #fff;
  padding: 0.2rem 0.15rem;
}
.title {
  font-size: 0.18rem;
  /* font-family: PingFangSC-Medium, PingFang SC; */
  /* font-weight: 500; */
  color: rgba(51, 51, 51, 1);
}
.mg {
  margin-left: 0.1rem;
}
.time {
  height: 0.32rem;
  background: rgba(247, 247, 247, 1);
  width: 100%;
  line-height: 32px;
  padding: 0 0.1rem;
  font-size: 0.12rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  margin: 0.1rem 0;
}
.eyes {
  display: inline-block;
  width: 0.11rem;
  height: 0.1rem;
  background: url('../../assets/img/information/eyes_btn.png') no-repeat top
    center;
  background-size: 100%;
  position: relative;
  top: 0.004rem;
  margin-right: 0.03rem;
}
.con {
  color: #666666;
  line-height: 26px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  font-size: 0.14rem;
  /* text-indent: 0.35rem; */
}
.bottom {
  font-size: 0.12rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(204, 204, 204, 1);
  text-align: center;
  padding-top: 0.15rem;
  /* position: fixed;
  bottom: 0.39rem;
  left: 50%;
  transform: translate(-50%, 0); */
}
</style>

